import { useContext, useEffect, useRef } from "react";
import Zoomist from "zoomist";
import { MAX_SCALE } from "../components/common/consts";
import WebcamState from "../controls/WebcamState";
import { useAppSelector } from "../store/index.ts";
import useStreamStatus from "./site/useStreamStatus.js";
import { ZoomContextRef } from "../pages/CurrentModel";

export default function useInitZoom() {
  const zoom = useAppSelector((state) => state.common.controls.zoom);
  const divZoomRef = useContext(ZoomContextRef);
  const { isStream } = useStreamStatus();

  const initZoomRef = useRef();

  useEffect(() => {
    const initZoom = async () => {
      try {
        if (WebcamState.zoomist) return;
        if (!isStream) return;

        console.log("initzoom");
        const options = { maxScale: MAX_SCALE, zoomer: false };
        WebcamState.zoomist = new Zoomist(divZoomRef.current, options);
        await WebcamState.zoomist.init();
        WebcamState.zoomist.on("zoom", (e) => {
          if (e.transform.scale === 1) e.transform.translateY = 0;
        });
      } catch (e) {
        clearTimeout(initZoomRef.current);
        initZoomRef.current = setTimeout(() => initZoom(), 500);
      }
    };

    initZoom();
  }, [isStream, divZoomRef]);

  useEffect(() => {
    if (WebcamState.zoomist?.transform?.scale) WebcamState.zoomist.transform.scale = zoom;
  }, [zoom]);

  useEffect(() => {
    WebcamState.zoomist = null;
    clearTimeout(initZoomRef.current);
  }, []);
}
